import { createAuth0Client } from "@auth0/auth0-spa-js";

let auth0Client = null;

export async function initAuth() {
  if (!auth0Client) {
    auth0Client = await createAuth0Client({
      domain: process.env.VUE_APP_AUTH_DOMAIN,
      clientId: process.env.VUE_APP_AUTH_CLIENT_ID,
      authorizationParams: {
        redirect_uri: process.env.VUE_APP_AUTH_REDIRECT_URI,
        scope: "openid profile email",
        audience: process.env.VUE_APP_AUTH_AUDIENCE,
      },
      cacheLocation: "localstorage", // optional but us eful
      useRefreshTokens: true // recommended
    });
  }
  return auth0Client;
}

export function getAuth0() {
  if (!auth0Client) throw new Error("Auth0 client not initialized. Call initAuth() first.");
  return auth0Client;
}